var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerHour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.35 11.84L3.206 0.0799996H4.466L1.61 11.84H0.35ZM6.1005 11V0.78H7.4445V6.884H7.1085C7.1085 6.14667 7.20183 5.512 7.3885 4.98C7.5845 4.43867 7.88317 4.02333 8.2845 3.734C8.68583 3.44467 9.19917 3.3 9.8245 3.3H9.8805C10.7765 3.3 11.4532 3.59867 11.9105 4.196C12.3678 4.784 12.5965 5.62867 12.5965 6.73V11H11.2525V6.45C11.2525 5.84333 11.0798 5.372 10.7345 5.036C10.3985 4.7 9.95983 4.532 9.4185 4.532C8.82117 4.532 8.3405 4.73267 7.9765 5.134C7.62183 5.526 7.4445 6.044 7.4445 6.688V11H6.1005Z",
    fill: "#9499A8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerHour);
export default __webpack_public_path__ + "static/media/PerHour.e6f5324a07c2011470ee0ebb393b49e2.svg";
export { ForwardRef as ReactComponent };